import { GenericErrorResponse } from './../../../shared/models/generic/generic-error-response.model';
import { LoginStorage } from './../../../login/login.storage';
import { Component, Input, OnInit } from '@angular/core';
import { FichaService } from '../../ficha-veiculo.service';
import { finalize } from 'rxjs/operators';
import { FichaTimelineSharedService } from '../ficha-timeline.shared.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-ficha-timeline-assinatura-digital',
  templateUrl: './ficha-timeline-assinatura-digital.component.html',
  styleUrls: ['./ficha-timeline-assinatura-digital.component.scss']
})
export class FichaTimelineAssinaturaDigitalComponent implements OnInit {

  @Input() timeline: any;
  @Input() timelineActive: boolean;
  @Input() proposta: any;

  isLoading = false;
  isLojista = false;

  constructor(
    private readonly service: FichaService,
    private readonly sharedService: FichaTimelineSharedService,
    private readonly loginStorage: LoginStorage
  ) { }

  ngOnInit(): void {
    this.setIsLojista();
  }

  onClickPrintDocument(): void {
    window.open(this.proposta.urlDocumentosUnificados, '_blank');
  }

  onClickResend(tipoComunicacao: string): void {
    this.isLoading = true;
    this.service.resendSign({ propostaId: this.proposta.id, tpComunicacao: tipoComunicacao })
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(
        (result) => {
          if (
            ((result as GenericErrorResponse) &&
              (result as GenericErrorResponse).status !== 'OK') &&
            (result as GenericErrorResponse).status !== 'SUCCESS'
          ) {
            if (
              (result as GenericErrorResponse) &&
              (result as GenericErrorResponse).messages
            ) {
              toastr.error((result as GenericErrorResponse).messages[0]);
              this.sharedService.reloadFicha();
              return;
            }
            if (
              (result as GenericErrorResponse) &&
              (result as GenericErrorResponse).message
            ) {
              toastr.error((result as GenericErrorResponse).message);
              this.sharedService.reloadFicha();
              return;
            }
          }
          this.sharedService.reloadFicha();
          toastr.success('As informações do pré-contrato foram reenviadas com sucesso');
        },
        () => toastr.error('Não conseguimos reenviar as informações do pré-contrato')
      );
  }

  get possuiUrlDocumentos(): boolean {
    return this.proposta.urlDocumentosUnificados;
  }

  getStatusMessage(): string {
    let mensagemStatus = '';
    this.timeline.cardDireito.some((card) => {
      if (card.tipo === 'TEXTO') {
        mensagemStatus = card.valor;
      }
    });
    return mensagemStatus;
  }

  hasResendButton(): string {
    let botaoReenviar = '';
    this.timeline.cardDireito.some((card) => {
      if (card.acoes && card.acoes[0].acao === 'REENVIAR') {
        botaoReenviar = card.valor;
      }
    });
    return botaoReenviar;
  }

  getPrintDocumentButton(): string {
    let botaoImprimirDocumento = '';
    this.timeline.cardDireito.some((card) => {
      if (card.acoes && card.acoes[0].acao === 'IMPRIMIR') {
        botaoImprimirDocumento = card.valor;
      }
    });
    return botaoImprimirDocumento;
  }

  setIsLojista(): void {
    this.isLojista = this.loginStorage.usuario.isLojista;
  }
}
